// League of Legends game config — scaffold (unify Phase 4).
// loldraftplan was forked from ygdraftplan and never fine-tuned: it reuses
// the Dota Captains Mode board layout as-is, with the LoL champion roster
// (Data Dragon 16.8.1). Real LoL pick/ban order still needs fine-tuning —
// change board.* here when you do, no component edits needed.
import heroIdMap from './heroIdMap';

const lol = {
  id: 'lol',
  name: 'League of Legends',

  features: {
    gsi: false,        // no Game State Integration outside Dota
    maps: false,
    everyonePremium: false,  // mirrors loldraftplan (yg-style tier enforcement)
  },

  // Dota CM layout, exactly as loldraftplan currently behaves (not yet tuned)
  board: {
    positionCount: 24,
    radiantBans: [1, 2, 5, 10, 11, 19, 21],
    radiantPicks: [8, 14, 15, 18, 23],
    direBans: [3, 4, 6, 7, 12, 20, 22],
    direPicks: [9, 13, 16, 17, 24],
    largeBoxSequences: ['8', '9', '13', '14', '15', '16', '17', '18', '23', '24'],
  },

  teams: { a: 'Blue', b: 'Red' },

  heroes: {
    idMap: heroIdMap,  // empty — no OpenDota equivalent; lookups fall back to slug
    imageCdn: 'https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/',
    defaultImage: 'https://ddragon.leagueoflegends.com/cdn/16.8.1/img/champion/Aatrox.png',
    idSource: 'Data Dragon 16.8.1',
  },

  // Placeholder, copied from loldraftplan/src/firebase/config.js — that app
  // was never deployed. Create a Firebase project and fill these in before
  // deploying the lol target.
  firebaseProjectId: 'YOUR_PROJECT_ID',
  firebase: {
    apiKey: "YOUR_API_KEY",
    authDomain: "YOUR_PROJECT_ID.firebaseapp.com",
    projectId: "YOUR_PROJECT_ID",
    storageBucket: "YOUR_PROJECT_ID.appspot.com",
    messagingSenderId: "YOUR_SENDER_ID",
    appId: "YOUR_APP_ID"
  },
};

export default lol;
